import { NetworkRequestState } from '../baseTypes';
import { ChangeEmailWidgetData } from './types';

const defaultChangeEmailWidgetData: NonNullable<
  ChangeEmailWidgetData['initialData']
> = {
  email: '',
  password: '',
};

export const defaultChangeEmailWidgetState: ChangeEmailWidgetData = {
  initialData: defaultChangeEmailWidgetData,
  currentData: defaultChangeEmailWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
  canUpdateEmail: false,
};
